import { Tooltip, Typography } from "@mui/material";
import dayjs from "configs/dayjs.config";

import React, { useEffect, useState } from "react";
import {
  dataFetchFrequency,
  dateTimeFormat,
} from "constants/componentsConstants";
import { getDaysLeftIndicatorColor } from "utils/functions/getIndicatorColor";
import { calculateDaysLeft } from "./daysDiffUtilityFunction";

export const TimeLeft = ({ targetDate, variant, fontSize, colorIndicator }) => {
  const [daysLeft, setDaysLeft] = useState(
    calculateDaysLeft(dayjs(targetDate))
  );
  useEffect(() => {
    const intervalId = setInterval(() => {
      setDaysLeft(calculateDaysLeft(dayjs(targetDate)));
    }, dataFetchFrequency.timeSinceAndLeft);
    return () => clearInterval(intervalId);
  }, [targetDate]);

  if (!targetDate) {
    return <Typography fontSize={fontSize}>-</Typography>;
  }
  let displayTime;
  displayTime = ` ${dayjs(targetDate).format(dateTimeFormat.date)}`;

  const getColor = () => {
    if (colorIndicator) {
      return getDaysLeftIndicatorColor(daysLeft);
    }
  };

  return (
    <Tooltip title={dayjs(targetDate).format(dateTimeFormat.date)}>
      {variant === "data" ? (
        <Typography component="span" color={getColor()} fontSize={fontSize}>
          {displayTime}
        </Typography>
      ) : (
        <Typography component="span" fontSize={10}>
          {displayTime}
        </Typography>
      )}
    </Tooltip>
  );
};
